export default __webpack_public_path__ + "static/media/T_Forms.fa5d9ab9.png";